import humanizeString from 'humanize-string'
import sortBy from 'lodash/sortBy'

import { TemporalCondition } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { ControlOptionsProps } from '@avantstay/backoffice-core'

import { dateTypeByTemporalCondition } from '@new/__global/components/DatePickerCustomFilter/DatePickerCustomFilter.definitions'

export const getPeriodReferenceValue = (periodReference?: TemporalCondition) =>
  periodReference ? dateTypeByTemporalCondition[periodReference] : undefined

export const getDateTypeOptions = (): ControlOptionsProps[] => {
  const customRangeOption = {
    id: 'custom-range',
    value: undefined,
    title: 'Custom range',
  }

  return sortBy(
    Object.values(TemporalCondition).map(
      option =>
        ({
          id: option.toString(),
          value: option,
          title: humanizeString(dateTypeByTemporalCondition[option]),
        }) as ControlOptionsProps,
    ),
    ['id'],
  )
    .reverse()
    .concat(customRangeOption)
}
